import { AfterViewInit, Component, effect, inject, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { RequestStatusV2 } from '@banyan/commons/enum/request-status-v2';
import { RequestV2 } from '@banyan/commons/models/request.model';
import { AdminService } from '@banyan/modules/admin/services/admin.service';

@Component({
  selector: 'app-admin-requests',
  templateUrl: './admin-requests.component.html',
  styleUrls: ['./admin-requests.component.scss'],
})
export class AdminRequestsComponent implements AfterViewInit {
    @ViewChild(MatPaginator) paginator!: MatPaginator;
    @ViewChild(MatSort) sort!: MatSort;
    adminService = inject(AdminService);
    REQUEST_COLUMNS: string[] = [
      'number',
      'company',
      'status',
      'date',
      'goto-request',
    ];
    dataSource = new MatTableDataSource<RequestV2>();
    displayedColumns: string[] = this.REQUEST_COLUMNS;
    totalRecords: number = 0;
    pageIndex: number = 0;
    pageSize: number = 10;
    protected readonly RequestStatusV2 = RequestStatusV2;
  
    constructor() {
      this.loadRequests(this.pageIndex, this.pageSize);

    this.dataSource.filterPredicate = (data: RequestV2, filter: string) => {
      const transformedFilter = filter.trim().toLowerCase();
      return (
        data.id.toString().toLowerCase().includes(transformedFilter) ||
        data.company?.name.toString().toLowerCase().includes(transformedFilter) ||
        data.status.toLowerCase().includes(transformedFilter)
      );
    };

    effect(() => {
      if (this.adminService.requestsLoaded()) {
        this.dataSource.data = this.adminService.requests()?.requests ?? [];
        this.totalRecords = this.adminService.requests()?.count ?? 0;
      }
    });
  }

  ngAfterViewInit() {
    this.sortingTable();
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  sortingTable() {
    if (this.dataSource) {
      this.dataSource.sort = this.sort;
      this.dataSource.sortingDataAccessor = (data: RequestV2, sortHeaderId: string) => {
        switch (sortHeaderId) {
          case 'number':
            return data.id;
          case 'createdAt':
            return new Date(data.createdAt);
          case 'status':
            return data.status;
          default:
            return (data as any)[sortHeaderId] ?? '';
        }
      };
    }
  }

    getStatusType(statusCode: RequestStatusV2): 'brand' | 'notification' | 'info' | 'trend' | 'green' {
      switch (statusCode) {
        case RequestStatusV2.new:
          return 'notification';
        case RequestStatusV2.proposal:
          return 'green';
        case RequestStatusV2.expired:
          return 'notification';
        case RequestStatusV2.updateRequested:
          return 'info';
        default:
          return 'notification';   
      }
    }
  
    onPageChange(event: any) {
      this.pageIndex = event.pageIndex;
      this.pageSize = event.pageSize;
      this.loadRequests(this.pageIndex, this.pageSize);
    }
  
    loadRequests(pageIndex: number, pageSize: number) {
      const startIndex = pageIndex * pageSize;
      this.adminService.getRequests(pageSize, startIndex);
    }
}
